/**
 *  orderStatus 订单状态
 * @param orderStatus
 */
export function orderStatusFormat(orderStatus) {
  let orderStatusStr = '';
  if (orderStatus === 'CREATE') {
    orderStatusStr = '新建';
  }
  if (orderStatus === 'SEND') {
    orderStatusStr = '发送';
  }
  if (orderStatus === 'CLOSED') {
    orderStatusStr = '关闭';
  }

  return orderStatusStr;
}
/**
 *  transportType 运输方式
 * @param transportType
 */
export function transportTypeFormat(transportType) {
  let transportTypeStr = '';
  if(transportType !== null){
    if (!transportType.indexOf('快递') || transportType === "汽运-跨越") {
      transportTypeStr = transportType;
    }else {
      transportTypeStr = "专车";
    }
  }
  return transportTypeStr;
}

function dataFormat(a) {
  let isAdminStr = '';
  if (a === 0) {
    isAdminStr = '商务人员';
  }
  if (a === 1) {
    isAdminStr = '管理人员';
  }

  return isAdminStr;
}
